/* eslint-disable no-console */
import { useCallback, useLayoutEffect, useState } from 'react'

import InterWebviewBridge, {
  interWbSession,
  WbEnvironments,
  IWbUserInfo,
} from '@interco/inter-webview-bridge'

import { userInfoMock } from '../mocks/userInfo'

type UseUserInfoResult = {
  userInfo: IWbUserInfo
  isLoading: boolean
  isError: boolean
  refetch: () => Promise<void>
}

export const useUserInfo = (): UseUserInfoResult => {
  const [userInfo, setUserInfo] = useState<IWbUserInfo>({} as IWbUserInfo)
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  const interWb = InterWebviewBridge.getInstance()

  const getUserInfo = useCallback(async () => {
    setIsLoading(true)
    setIsError(false)

    if (
      interWb.getEnvironment() === WbEnvironments.BROWSER &&
      process.env.NODE_ENV === 'development'
    ) {
      setUserInfo(userInfoMock)
      setIsLoading(false)
      return
    }

    try {
      const data = await interWbSession.getUserInfo()
      setUserInfo(data)
    } catch (error) {
      console.error('useUserInfo: failed to load user info from the native bridge', error)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }, [interWb])

  useLayoutEffect(() => {
    getUserInfo()
  }, [getUserInfo])

  return { userInfo, isLoading, isError, refetch: getUserInfo }
}
